<template>
  <div class="tw-bg-white tw-min-h-screen tw-relative tw-w-screen">

    <template v-if="loading">
      <div class="tw-flex tw-items-center tw-justify-center tw-min-h-screen">
        <p class="opacity-54">Welcome. Please wait...</p>
      </div>
    </template>

    <template v-else>
      <!-- fold section -->
      <section class="tw-w-screen fold-section tw-relative tw-z-10 tw-block">
        <!-- header -->
        <header class="tw-flex tw-items-center justify-between tw-mx-6 sm:tw-mx-18 xl-app:mx-body tw-overflow-overlay tw-py-4">
          <!-- eslint-disable max-len -->
          <!-- logo -->
          <div class="tw-flex-shrink-0 tw-flex tw-items-center">
            <EmentoredAppLogo
              height="40"
              width="40"
              icon
              class="tw-flex-shrink-0 transform-scale-0"
              bgColor="var(--maroon)"
            />
            <div style="height: 40px; width: 1px; transform: rotate(14deg)" class="tw-mx-4 tw-bg-gray-800"></div>
            <div>
              <img
                :src="appLogoUrl"
                :key="appLogoUrl"
                alt="eMentored"
                width="auto"
                class="tw-h-12 tw-w-auto tw-max-w-3xl tw-object-contain tw-block tw-flex-shrink-0 transform-scale-0"
              >
            </div>
          </div>

          <div class="tw-flex-grow"></div>

          <BaseButton
            text="login"
            class="tw-bg-app-deep-blue tw-border-none tw-rounded-10 tw-text-app-light-blue tw-py-3 sm:tw-py-4 tw-px-6 tw-text-base tw-leading-none sm:tw-shadow-app"
            to="/login"
          />
        </header>

        <div></div>
        <div class="tw-z-30 tw-block tw-relative">

          <!-- cta -->
          <div class="tw-flex tw-z-30 tw-items-center tw-relative tw-flex-wrap tw-mx-6 sm:tw-mx-18 xl-app:mx-body">
            <div class="tw-flex-shrink-0 tw-flex-grow-0 lg:tw-w-3/4 tw-w-full tw-my-24 sm:tw-my-40 xl-app:tw-my-56 tw-relative tw-z-20">
              <h1 class="tw-text-app-light-blue font-title tw-font-semibold tw-text-4xl sm:tw-text-5xl tw-leading-tight tw-tracking-wide">
                {{ landingpageText }}
              </h1>
              <div class="tw-w-full tw-mt-18">
                <BaseButton
                  text="Become a Mentor"
                  class="tw-bg-app-orange tw-border-none tw-rounded-10 tw-text-app-maroon tw-py-5 tw-px-8 tw-text-xl tw-leading-tight tw-font-bold tw-font-sans tw-uppercase tw-mb-6 sm:tw-mr-10"
                  to="/mentor-signup"
                />
                <BaseButton
                  text="Find a Mentor"
                  class="tw-bg-app-orange tw-border-none tw-rounded-10 tw-text-app-maroon tw-py-5 tw-px-8 tw-text-xl tw-leading-tight tw-font-bold tw-font-sans tw-uppercase"
                  to="/mentee-signup"
                />
              </div>
            </div>
          </div>

          <div class="fold-section__bg tw-z-10 tw-bg-black tw-opacity-50 tw-h-full tw-w-full tw-absolute tw-top-0 tw-left-0"></div>

          <img
            class="fold-section__image tw-z-0 tw-h-full tw-w-full tw-absolute tw-top-0 tw-left-0 tw-object-cover"
            async
            :key="landingpageBgImage"
            :src="landingpageBgImage"
            :data-src="landingpageBgImage"
          >

        </div>
      </section>

      <!-- footer -->
      <section class="tw-w-screen tw-relative footer-section tw-z-10 tw-bg-app-light-blue">
        <div></div>
        <div class="tw-z-30 tw-block tw-pt-24 sm:pt-body px-body tw-relative">
          <div class="tw-flex tw-flex-wrap sm:tw-flex-no-wrap tw-justify-between tw-relative">
            <div class="tw-flex-shrink-0 tw-z-10">
              <!-- address -->
              <h3 class="tw-font-bold tw-text-3xl sm:tw-text-4xl tw-tracking-wide tw-capitalize tw-font-sans tw-text-left tw-mb-6">Contact Us</h3>
              <p class="tw-text-app-dark-gray tw-text-sm sm:tw-text-base font-nunito">
                eMentoring Africa<br>
                P.O BOX 849-00600, Nairobi<br>
                Tel: <a href="tel:+254705185570" class="tw-font-bold">+254 705 185570</a>
              </p>

              <div class="flex tw-items-start">
                <div class="tw-inline-block">
                  <p class="tw-text-sm sm:tw-text-base font-nunito tw-pr-1 tw-inline-block">Email:</p>
                  <br>
                  <br>
                </div>
                <div class="tw-inline-block">
                  <a class="tw-font-bold tw-text-sm sm:tw-text-base font-nunito tw-inline-block" href="mailto:mentor@ementoringafrica.or.ke">
                    mentor@ementoringafrica.or.ke
                  </a>
                  <br>
                  <a class="tw-font-bold tw-text-sm sm:tw-text-base font-nunito tw-inline-block" href="mailto:info@ementoringafrica.or.ke">
                    info@ementoringafrica.or.ke
                  </a>
                </div>
              </div>
            </div>

            <div class="tw-z-0 footer-section__links tw-mt-8 sm:tw-mt-0">
              <!-- links -->
              <router-link to="/login" class="tw-text-base tw-text-app-blue tw-block">Login</router-link>
              <router-link to="/mentor-signup" class="tw-text-base tw-text-app-blue tw-block">Mentor Signup</router-link>
              <router-link to="/mentee-signup" class="tw-text-base tw-text-app-blue tw-block">Mentee Signup</router-link>
            </div>
          </div>

          <div class="tw-flex tw-flex-wrap sm:tw-flex-no-wrap tw-justify-between tw-relative tw-mt-24 sm:tw-mt-48 tw-py-10">
            <a
              href="https://ementoringafrica.or.ke"
              target="_blank"
              class="tw-text-app-deep-blue font-title tw-leading-tight tw-w-full sm:tw-w-auto tw-mb-6 sm:tw-mb-0 tw-text-center sm:tw-text-left"
            >
              eMentored &trade; is a product of eMentoring Africa
            </a>

            <p class="tw-text-app-dark-gray font-title tw-w-full sm:tw-w-auto tw-leading-none tw-text-center sm:tw-text-left">
              eMentored Copyright &copy; {{ thisYear }}
            </p>
          </div>
        </div>
      </section>
    </template>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import visitorsMixin from '@/mixins/visitors';
import EmentoredAppLogo from '@/components/EmentoredAppLogo.vue';

const email = 'info@ementoringafrica.or.ke';
const landingpageText = 'Connecting mentors and mentees on a mutual-growth journey';
const landingpageBgImage = '/img/fold-bg.JPG';

export default {
  name: 'CompanyHome',
  mixins: [visitorsMixin],
  components: {
    EmentoredAppLogo,
  },
  computed: {
    ...mapState({
      landingpageText: state => state.settings.landingpage.text || landingpageText,
    }),
    landingpageBgImage() {
      if (this.$store.state.settings.landingpage.bgImage) {
        return this.userPhoto(this.$store.state.settings.landingpage.bgImage);
      }
      return landingpageBgImage;
    },
    talkToUsEmailHref() {
      return `mailto:${email}`;
    },
    thisYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
@import url("../assets/css/landingpage.css");
</style>
